import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';

export default function PromoCodes() {
  const [items, setItems] = useState([]);
  const [code, setCode] = useState('');
  const [sparkAmount, setSparkAmount] = useState('');
  const [validBefore, setValidBefore] = useState('');
  const [maxRedemptions, setMaxRedemptions] = useState('');
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/promo-codes`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const create = async () => {
    if (!sparkAmount || !validBefore) return;
    setError('');
    setCreating(true);
    try {
      await axios.post(`${API}/admin/promo-codes`, {
        code: code.trim() || null, spark_amount: Number(sparkAmount), valid_before: validBefore,
        max_redemptions: maxRedemptions ? Number(maxRedemptions) : null,
      }, { headers: authHeaders() });
      setCode(''); setSparkAmount(''); setValidBefore(''); setMaxRedemptions('');
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось создать промокод'));
    }
    setCreating(false);
  };

  const toggleActive = async (p) => {
    await axios.patch(`${API}/admin/promo-codes/${p.id}`, { is_active: !p.is_active }, { headers: authHeaders() });
    fetchItems();
  };

  return (
    <Layout>
      <h1 style={ui.title}>Промокоды</h1>

      <div style={ui.card}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>Новый промокод</div>
        <div style={ui.row}>
          <input style={{ ...ui.input, fontFamily: 'monospace' }} placeholder="Код (необязательно, иначе сгенерируем)" value={code} onChange={e => setCode(e.target.value.toUpperCase())} />
          <input style={ui.input} type="number" placeholder="Кол-во искр" value={sparkAmount} onChange={e => setSparkAmount(e.target.value)} />
          <input style={ui.input} type="date" placeholder="Действует до" value={validBefore} onChange={e => setValidBefore(e.target.value)} required />
          <input style={ui.input} type="number" placeholder="Лимит использований (необязательно)" value={maxRedemptions} onChange={e => setMaxRedemptions(e.target.value)} />
          <button style={ui.btn} onClick={create} disabled={creating || !sparkAmount || !validBefore}>{creating ? 'Создаём…' : 'Создать код'}</button>
        </div>
        <div style={{ fontSize: 12, color: colors.textMuted, marginTop: 8 }}>
          Дата обязательна. Если задан ещё и лимит использований — сработает то ограничение, которое наступит раньше.
        </div>
        {error && <div style={ui.error}>{error}</div>}
      </div>

      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={p => p.id}
          emptyText="Промокодов пока нет"
          columns={[
            { key: 'code', label: 'Код', render: p => <span style={{ fontFamily: 'monospace' }}>{p.code}</span> },
            { key: 'spark_amount', label: 'Искры' },
            { key: 'valid_before', label: 'Действует до' },
            {
              key: 'redemptions_count', label: 'Погашений',
              render: p => (p.max_redemptions ? `${p.redemptions_count} / ${p.max_redemptions}` : p.redemptions_count),
            },
            { key: 'is_active', label: 'Активен', sortValue: p => (p.is_active ? 1 : 0), render: p => (p.is_active ? 'Да' : 'Нет') },
            {
              key: 'actions', label: '', sortable: false,
              render: p => (
                <button style={ui.btnSecondary} onClick={() => toggleActive(p)}>
                  {p.is_active ? 'Отключить' : 'Включить'}
                </button>
              ),
            },
          ]}
        />
      </div>
    </Layout>
  );
}
